import React, { memo, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import config from "../../../config/app-config";

import { Box, Flex, Menu, MenuButton, MenuList, MenuItem, Button, useToast } from '@chakra-ui/react'
import { updateDsr, resetUpdateDsrOutcome, changeDsrModalState, changeDsrPopupState } from '../actions/dsr-actions';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import FormTextInput from '../../forms/TextInputField/components/FormTextInput'
import { checkIfInteger, displayMoney, getThisUserIdToken, openInNewTab, triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import { IoChevronDownOutline } from 'react-icons/io5';
import { SiBrandfolder } from 'react-icons/si'
import { AiOutlineIdcard } from 'react-icons/ai'
import LaunchdeckSwitch from '../../global/components/helper-components/components/LaunchdeckSwitch'

function DsrRoomSettingsPage({
  // Parent component
  dsrId,
  dsrProperties,
  // Redux actions
  updateDsr,
  resetUpdateDsrOutcome,
  changeDsrPopupState,
  changeDsrModalState,
  // Redux state
  isMobileView,
  dsrStatusRedux,
  updateDsrOutcome,
  dsrBrandingOptions
}) {

  const toast = useToast();

  const [editCurrencyValueMode, setEditCurrencyValueMode] = useState(false)
  const [logoDisplayMode, setLogoDisplayMode] = useState("")
  const [latestDsrProperties, setLatestDsrProperties] = useState("")
  const [applyBranding, setApplyBranding] = useState(null)

  const { dealValue } = latestDsrProperties || {};
  const { currency, numberValue } = dealValue || {};
  const displayedDealValue = numberValue ? displayMoney("", numberValue) : "-" // Display without currency
  const currencyValueRef = useRef(null);

  useEffect(() => {
    if (dsrProperties) {
      setLatestDsrProperties(dsrProperties)
      setLogoDisplayMode(dsrProperties.logoDisplayOption ? dsrProperties.logoDisplayOption : "default")

      const { applyBranding } = dsrProperties || {};
      setApplyBranding(applyBranding)
    }
  }, [dsrProperties]);

  useEffect(() => {
    if (updateDsrOutcome) {
      const { updateDsrStatus, sourceEvent 
        // updatedDsrId, 
      } = updateDsrOutcome || {};

      switch (sourceEvent) {
        case ("save-room-properties"): {
          // if (updateDsrStatus && updatedDsrId === dsrId && dsrId !== undefined) {
          //   toast(
          //     triggerLaunchdeckToast({
          //       useCase: "show-success-state",
          //       label: "Room settings successfully updated",
          //       isMobileView
          //     })
          //   )
          // } else 
          if (!updateDsrStatus) {
            toast(
              triggerLaunchdeckToast({
                useCase: "show-error-state",
                label: "Unfortunately something went wrong. Please try again later.",
                isMobileView
              })
            )
          }

          resetUpdateDsrOutcome()
          break;
        }
        default: {
          console.log(`There is no such sourceEvent: ${sourceEvent}`)
          break;
        }
      }
    }
  }, [updateDsrOutcome, toast, dsrId, resetUpdateDsrOutcome, isMobileView]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if ((editCurrencyValueMode && currencyValueRef.current) && !currencyValueRef?.current.contains(event.target)) {
        setEditCurrencyValueMode(false);
        handleSaveDsrProperties();
      }
    };

    if (editCurrencyValueMode) {
      setTimeout(() => window.addEventListener('mousedown', handleClickOutside), 100)
    } else {
      window.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [editCurrencyValueMode, latestDsrProperties]);

  const onChangeHandler = event => {
    switch (event.target.name) {
      case ('dealValue'): {
        const { checkedValue, isInteger } = checkIfInteger(event.target.value)

        if (!!isInteger) {
          const updatedDsrProperties = {
            ...latestDsrProperties,
            dealValue: {
              ...dealValue,
              numberValue: parseInt(checkedValue)
            }
          }

          setLatestDsrProperties(updatedDsrProperties)
        }

        break;
      }
      default: {
        break;
      }
    }
  };

  const handleSaveDsrProperties = () => {
    if (dsrId) {
      updateDsr({
        dsrId: dsrId,
        dsrProperties: latestDsrProperties,
        sourceEvent: "save-room-properties"
      })
    }
  }

  const handleSaveRoomSettings = (mode, changedValue) => {
    let updatedDsrProperties = "";
    let instantSave = false;

    switch (mode) {
      case ("currency"): {
        const { currency } = changedValue || {}
        if (currency) {
          updatedDsrProperties = {
            ...latestDsrProperties,
            dealValue: {
              ...dealValue,
              currency: currency
            }
          }

          instantSave = true;
        }


        break;
      }
      case ("room-value"): {
        const { numberValue } = changedValue || {}
        if (numberValue) {
          updatedDsrProperties = {
            ...latestDsrProperties,
            dealValue: {
              ...dealValue,
              numberValue: parseInt(numberValue)
            }
          }

          instantSave = false; // Don't autosave since it depends on clicking outside
        }

        break;
      }
      case ("logo-display-option"): {
        const { option } = changedValue || {}
        if (option) {
          updatedDsrProperties = {
            ...latestDsrProperties,
            logoDisplayOption: option
          }

          instantSave = true;
        }
        break;
      }
      case ("apply-room-branding"): {
        updatedDsrProperties = {
          ...latestDsrProperties,
          applyBranding: !applyBranding,
          orgBrandOwnerUserId: (applyBranding === false) ? getThisUserIdToken() : "" // Inverse logic since setting the value comes later
        }

        setApplyBranding(!applyBranding)
        instantSave = true;

        break;
      }
      default: {
        break;
      }
    }

    updatedDsrProperties && setLatestDsrProperties(updatedDsrProperties)

    if (dsrId && !!instantSave) {
      updateDsr({
        dsrId: dsrId,
        dsrProperties: updatedDsrProperties,
        sourceEvent: "save-room-properties"
      })
    }
  }
  
  return (
    <Box>
      <Flex justify='space-between' align='center'>
        <Box>
          <Box color='brandDark.500' fontSize='1.5em' lineHeight='1.4em' fontWeight='600'>Room Settings</Box>
          <Box color='brandDark.500' fontSize={['0.75em', '0.75em', '0.875em', '0.875em']} fontWeight='400'>
            Manage Room settings here
          </Box>
        </Box>
      </Flex>

      {/* <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' mt='1.5em'>

        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em'>Client Info</Box>

        <Flex w='100%' justify='flex-start' align='center'>
          <Box lineHeight='1.275em' fontWeight='500' my='1em' fontSize='0.875em'>
            Client name
          </Box>
        </Flex>

        <FormTextInput
          name={'clientName'}
          onChange={onChangeHandler}
          defaultValue={clientName}
          mb='0em'
          mt='0em'
        />

        <Flex w='100%' justify='flex-start' align='center'>
          <Box lineHeight='1.275em' fontWeight='500' my='1em' fontSize='0.875em'>
            Client website
          </Box>

        </Flex>

        <FormTextInput
          name={'clientWebsiteUrl'}
          onChange={onChangeHandler}
          defaultValue={clientWebsiteUrl}
          // color={textColor}
          mb='0em'
          mt='0em'
        />


        <Flex w='100%' justify='flex-end' mt='2em'>
          <LaunchdeckButton bg='brand.500' color='white' onClick={() => handleSaveDsrProperties()} label='Save' />
        </Flex>
      </Box> */}

      {/* {dsrStatusRedux === "active" &&
        <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>
          <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Share Room with QR code</Box>
          <Box display='flex' width='100%' justifyContent='center' my='2em'>
            <QRCodeSVG value={publishedDsrLinkDisplay ? publishedDsrLinkDisplay : ''} />
          </Box>
        </Box>
      } */}

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>

        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Display options</Box>

        <React.Fragment>
          <Flex w='100%' justify='space-between' align='center' py='1.5em'>
            <Box>
              <Box lineHeight='1.25em' fontWeight='500'>
                Logo display
              </Box>
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                Customise how logos are displayed
              </Box>
            </Box>
          </Flex>

          <Flex w='100%' p='0.5em'>
            <Flex w='100%' gap={8}>
              <Box flex='1' border={logoDisplayMode === "default" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "default" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "default" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                onClick={() => {
                  if (logoDisplayMode !== "default") {
                    handleSaveRoomSettings("logo-display-option", { option: "default" });
                    setLogoDisplayMode("default");
                  }
                }
                }
                transition='all 0.1s ease-in-out'
                justifyItems='center'
              >
                <Flex w='3em' h='3em' justify='center' align='center'>
                  <Box as={SiBrandfolder} boxSize='1em' />
                </Flex>

                <Box fontSize='0.8em' mt='1em'>Normal size</Box>
              </Box>

              <Box flex='1' border={logoDisplayMode === "large-logos" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "large-logos" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "large-logos" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                onClick={() => {
                  if (logoDisplayMode !== "large-logos") {
                    handleSaveRoomSettings("logo-display-option", { option: "large-logos" });
                    setLogoDisplayMode("large-logos");
                  }
                }
                }
                transition='all 0.1s ease-in-out'
                justifyItems='center'
              >
                <Flex w='3em' h='3em' justify='center' align='center'>
                  <Box as={SiBrandfolder} boxSize='2em' />
                </Flex>
                <Box fontSize='0.8em' mt='1em'>Larger logos</Box>
              </Box>

              <Box flex='1' border={logoDisplayMode === "nametag" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "nametag" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "nametag" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                onClick={() => {
                  if (logoDisplayMode !== "nametag") {
                    handleSaveRoomSettings("logo-display-option", { option: "nametag" });
                    setLogoDisplayMode("nametag");
                  }
                }
                }
                transition='all 0.1s ease-in-out'
                justifyItems='center'
              >
                <Flex w='3em' h='3em' justify='center' align='center'>
                  <Box as={AiOutlineIdcard} boxSize='1.5em' />
                </Flex>
                <Box fontSize='0.8em' mt='1em'>Nametag</Box>
              </Box>
            </Flex>
          </Flex>
        </React.Fragment>

        <React.Fragment>
          <Flex w='100%' justify='space-between' align='center' py='1.5em'>
            <Box>
              <Box lineHeight='1.25em' fontWeight='500'>
                Branding colors
              </Box>
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                Apply Room owner's brand colors
              </Box>
            </Box>
          
            <Flex pr='0.5em'>
            {dsrBrandingOptions ?
              <LaunchdeckSwitch
                name="applyRoomBranding"
                isChecked={applyBranding}
                onChange={() => handleSaveRoomSettings("apply-room-branding", {})}
                yesContent='"On"'
                noContent='"Off"'
                yesBg="brandDark.500"
                noBg=""
              />
              :
              <LaunchdeckButton onClick={()=>openInNewTab(`${config.displayUrl}/profile?section=set-brand-colors`)} bg='gray.100' color='brandDark.500' label='Not set' />
            }

            </Flex>

          </Flex>



        </React.Fragment>

        <Flex w='100%' justify='space-between' align='center' py='1.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Page content
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Choose whether to hide or lock your pages
            </Box>
          </Box>
          <Box mt={['0', '0', '1em', '1em']}>
            <LaunchdeckButton bg='brandDark.500' color='white' onClick={() => {
              changeDsrPopupState('mass-manage-dsr-custom-pages')
              changeDsrModalState(true)
            }} label='Manage pages' />
          </Box>
        </Flex>

      </Box>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' mt='1.5em'>
        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em'>Organize</Box>

        <Box w='100%' my='1.5em'>
          {/* <Flex w='100%' justify='space-between' align='center'>
            <Box lineHeight='1.275em' fontWeight='500' my='1em'>
              Room Name
            </Box>

            <Box>
              <FormFieldCharactersRemaining
                currentValue={dsrTitleRedux}
                characterLimit={maxDsrTitleLength}
              />
            </Box>
          </Flex>
          <FormTextInput
            name={'dsrTitle'}
            onChange={onChangeHandler}
            defaultValue={dsrTitleRedux}
            charLimit={maxDsrTitleLength}
            mb='0em'
            mt='0em'
          /> */}

          {/* <Flex w='100%' justify='space-between' align='center' mt='1.5em'>
            <Box lineHeight='1.275em' fontWeight='500' my='1em'>
              Room notes
            </Box>
          
          </Flex>

          <Box w='100%' border='1px solid' borderColor='gray.200' rounded='0.25em'>
            <InputTextAreaExpandable
              name={'roomDescription'}
              onChangeHandler={onChangeHandler}
              inputValue={roomDescription}
              placeholder={""}
            />
          </Box> */}


          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Deal Value
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Help your team set priorities
            </Box>
          </Box>


          <Flex my='1em' w='100%' justify='center' align='center'>
            <Menu mb='0em'>
              <MenuButton as={Button} rightIcon={<IoChevronDownOutline />} height='2.5em' fontSize='0.875em' lineHeight='1.275em'>
                <Box px='0.5em'>{currency ? currency : "USD"}</Box>
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => handleSaveRoomSettings('currency', { currency: 'USD' })}>{"USD"}</MenuItem>
                <MenuItem onClick={() => handleSaveRoomSettings('currency', { currency: 'GBP' })}>{"GBP"}</MenuItem>
                <MenuItem onClick={() => handleSaveRoomSettings('currency', { currency: 'EUR' })}>{"EUR"}</MenuItem>
                {/* // Allow custom input of 3 letter currency acronym */}
              </MenuList>
            </Menu>

            <Flex ref={currencyValueRef} w='100%' justify='flex-start'>
              {editCurrencyValueMode ?
                <FormTextInput
                  name={'dealValue'}
                  type='number'
                  onChange={onChangeHandler}
                  defaultValue={numberValue}
                  mb='0em'
                  mt='0em'
                  w='100%'
                />
                :

                <Box as="div" ml='0.5em' minW='20em' cursor='pointer' onClick={() => {
                  setEditCurrencyValueMode(true)
                }}> {displayedDealValue} </Box>

              }
            </Flex>
          </Flex>
        </Box>


      </Box>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>

        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Unpublish Room</Box>

        <Flex w='100%' justify='space-between' align='center' py='1.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Revert back to draft state
            </Box>
            {dsrStatusRedux === "active" ?
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em' pr='2em'>
                Content is retained, members will be unable to access the Room until you re-publish it again
              </Box> :
              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                Room is currently unpublished
              </Box>}
          </Box>

          {dsrStatusRedux === "active" ?
            <Box mt={['0', '0', '1em', '1em']}>
              <LaunchdeckButton bg='brandDark.500' color='white' onClick={() => {
                changeDsrPopupState('revert-dsr-to-draft')
                changeDsrModalState(true)
              }} label='Unpublish' />
            </Box>
            :
            <Box mt={['0', '0', '1em', '1em']}>
              <LaunchdeckButton dummy={true} bg='gray.100' color='gray.500' label='Unpublish' />
            </Box>
          }


        </Flex>
      </Box>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>
        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Danger Zone</Box>

        <Flex w='100%' justify='space-between' align='center' py='1.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Delete this Room
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Room content & members will be removed. This action cannot be undone.
            </Box>
          </Box>

          <Box>
            <LaunchdeckButton bg='gray.100' color='#DA3739' onClick={() => {
              changeDsrPopupState('delete-dsr')
              changeDsrModalState(true)
            }} label='Delete' />
          </Box>


        </Flex>
      </Box>


    </Box >

  )

}

const mapStateToProps = (state) => {
  return {
    dsrStatusRedux: state.dsrStatus.status,
    updateDsrOutcome: state.updateDsrOutcome.results.data,
    dsrBrandingOptions: state.dsrBrandingOptions.results,
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    isMobileView: state.mobileViewMode.isMobileView
  }
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr,
      resetUpdateDsrOutcome,
      changeDsrPopupState,
      changeDsrModalState
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrRoomSettingsPage)))
